var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))]),(_vm.text)?_c('p',{staticClass:"subheader"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }